import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()

  const mvSlideClass = '.js-topMvSlide'
  const mvSlidePagination = document.querySelector(mvSlideClass + '-pagination')
  // eslint-disable-next-line no-unused-vars
  const slideSpeed = 1000
  const slideDelay = 5000
  const mvSlide = new Swiper(mvSlideClass, {
    loop: true,
    speed: slideSpeed,
    effect: 'fade',
    autoplay: {
      delay: slideDelay,
    },
    on: {
      init: function () {
        const currentIndex = this.realIndex + 1
        const nextIndex = this.realIndex + 2
        document.getElementsByClassName('js-topMvSlide-current').item(0).textContent = '0' + currentIndex
        document.getElementsByClassName('js-topMvSlide-next').item(0).textContent = '0' + nextIndex
        mvSlidePagination.classList.add('active')
      },
      slideChange: function () {
        const currentIndex = this.realIndex + 1
        const nextIndex = this.realIndex + 1 < 3 ? this.realIndex + 2 : 1
        document.getElementsByClassName('js-topMvSlide-current').item(0).textContent = '0' + currentIndex
        document.getElementsByClassName('js-topMvSlide-next').item(0).textContent = '0' + nextIndex
      },
      slideChangeTransitionStart: function () {
        mvSlidePagination.classList.remove('active')
      },
      slideChangeTransitionEnd: function () {
        mvSlidePagination.classList.add('active')
      },
    },
  })
}

function page() {
  // TOPページの処理
  window.intObs = function () {
    if (document.getElementsByClassName('js-topMv')[0]) {
      const intObsOption = {
        // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
        rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
        threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
      }
      const observer = new IntersectionObserver(intObsCallback, intObsOption)
      const intObsItems = document.querySelectorAll('.js-topMv')
      const elmHeader = document.getElementById('header')
      for (let index = 0; index < intObsItems.length; index++) {
        const intObsItem = intObsItems[index]
        observer.observe(intObsItem) // 監視対象に加える
      }
      function intObsCallback(entries) {
        for (let index = 0; index < entries.length; index++) {
          const entry = entries[index]
          if (entry.isIntersecting) {
            const entryItem = entry.target
            elmHeader.classList.add('onMv')
          } else {
            const entryItem = entry.target
            elmHeader.classList.remove('onMv')
          }
        }
      }
    }
    if (document.getElementsByClassName('js-topReason')[0]) {
      const intObsOption = {
        // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
        rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
        threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
      }
      const observer = new IntersectionObserver(intObsCallback, intObsOption)
      const intObsItems = document.querySelectorAll('.js-topReason')
      for (let index = 0; index < intObsItems.length; index++) {
        const intObsItem = intObsItems[index]
        observer.observe(intObsItem) // 監視対象に加える
      }
      function intObsCallback(entries) {
        for (let index = 0; index < entries.length; index++) {
          const entry = entries[index]
          const entryItem = entry.target
          if (entry.isIntersecting) {
            entryItem.classList.add('active')
          } else if (entry.boundingClientRect.y > 0) {
            entryItem.classList.remove('active')
          }
        }
      }
    }
  }
  window.intObs() // 画面交差API起動
}
